<template>
  <v-container fluid class="pa-0">
    <v-card class="elevation-0">
      <!-- Background Image -->
      <div class="footer-bg">
        <v-container>
          <div class="mt-10 mx-lg-8 pt-lg-10">
            <v-row>
              <!-- Left column -->
              <v-col cols="12" sm="3" class="mx-1">
                <div class="pa-4 white--text">
                  <div class="d-flex align-center">
                    <img
                      src="@/assets/buyuk-final.jpg"
                      alt="Image description"
                      style="width: 120px; border-radius: 9px"
                    />
                  </div>
                  <p class="mt-4 text-justify black--text">
                    We promise that the projects that are designed and developed by us
                    will be the best with industry standards and will be built using
                    high-end technologies and will be delivered ahead of committed,
                    scheduled time.
                  </p>
                </div>
              </v-col>

              <!-- Spacer -->
              <v-col cols="12" lg="1" class="d-none d-lg-block"></v-col>

              <!-- Middle column -->
              <v-col cols="12" sm="2" lg="2" class="mx-1">
                <div class="pa-4">
                  <h2 class="linespht black--text">Buyuk</h2>
                  <p class="mt-4 black--text">About Us</p>
                  <p class="mt-2 black--text">Services</p>
                  <p class="mt-2 black--text">Community</p>
                  <p class="mt-2 black--text">Testimonial</p>
                </div>
              </v-col>

              <!-- Right column -->
              <v-col cols="12" sm="6" lg="5" class="mx-1">
                <div class="pa-4">
                  <h2 class="linespht black--text">Contact Us</h2>
                  <p class="mt-4 black--text">Mob : +91 8547797619, +91 7558049619</p>
                  <p class="mt-2 black--text">Email : info@buyuksoftwaresolutions.com</p>
                  <p class="mt-2 black--text">Street Address</p>
                  <p class="mt-2 black--text">
                    #7, Technolodge Peebo Rural IT Infrastructure Developers LLP, Piravom,
                    686662
                  </p>
                  <p class="mt-2 black--text">Website : www.buyuksoftwaresolutions.com</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <!-- Copyright -->
        <v-card flat class="mt-6 transparent">
          <v-card-text class="text-center mx-auto">
            <p class="body-1 black--text mb-0">
              Copyright © 2025 Buyuk Software Solutions Pvt. Ltd. All Rights Reserved.
              Design: Buyuk
            </p>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>

<style scoped>
.footer-bg {
  background: url("@/assets/footer.jpg") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: auto;
  padding: 40px 0; /* spacing around content */
}
</style>
